
(()=>{if(window.__faOuterbloomFilterV9)return;window.__faOuterbloomFilterV9=true;
const ROOT='.facets-container[data-template="collection"]';
const ORDER=['sort','delivery','flower-type','product-type','occasion','color','price','recipient','style'];
const LABEL={sort:'Sort',delivery:'Delivery to','flower-type':'Flower Type','product-type':'Product Type',style:'Style',occasion:'Occasion',color:'Colour',price:'Price Range',recipient:'Recipient'};
const STATE=new WeakMap();
let raf=0;

const norm=v=>String(v||'').replace(/\s+/g,' ').replace(/\(\d+\)\s*$/,'').trim().toLowerCase();
const cleanPriceValue=v=>{const raw=String(v??'').trim().replace(/,/g,'');if(!raw)return'';const n=Number(raw);return Number.isFinite(n)&&n>=0?String(n):''};
const slug=v=>norm(v).replace(/&/g,' and ').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
const names=d=>[...d.querySelectorAll('input[name],select[name]')].map(x=>x.name).filter(Boolean);

function parts(root){
  const wrapper=root.querySelector('.mobile-facets__wrapper');
  const disclosure=wrapper&&wrapper.querySelector(':scope>details.mobile-facets__disclosure');
  const opener=disclosure&&disclosure.querySelector(':scope>summary');
  const inner=disclosure&&disclosure.querySelector('.mobile-facets__inner');
  const list=inner&&inner.querySelector('#FacetsWrapperMobile');
  const form=inner&&inner.closest('form#FacetFiltersFormMobile');
  return{wrapper,disclosure,opener,inner,list,form};
}

function keyFor(d){
  const a=names(d),joined=a.join(' '),txt=norm(d.querySelector(':scope>summary')?.textContent||d.textContent),id=(d.id||'').toLowerCase();
  if(id.includes('sortby')||a.includes('sort_by'))return'sort';
  if(a.some(x=>x==='filter.p.m.custom.delivery_cities'||x==='filter.p.m.custom.deliveries')||txt.includes('delivery'))return'delivery';
  if(a.includes('filter.p.product_type')||txt==='product type')return'product-type';
  if(/custom\.flower_type/.test(joined)||txt==='flower type')return'flower-type';
  if(/custom\.(style|styles|arrangement_style|product_style)/.test(joined)||txt==='style')return'style';
  if(/custom\.(ocassionevent|occasion|occasions)/.test(joined)||txt.startsWith('occasion'))return'occasion';
  if(/custom\.colou?r/.test(joined)||/^colou?r$/.test(txt))return'color';
  if(a.some(x=>x==='filter.v.price.gte'||x==='filter.v.price.lte')||txt.includes('price'))return'price';
  if(/custom\.recipient_type/.test(joined)||txt.startsWith('recipient'))return'recipient';
  return slug(txt||a[0]||id||'filter');
}

function collectionContext(root){
  const h=String(root?.dataset.collectionHandle||'').toLowerCase();
  if(/^roses(?:-|$)/.test(h))return'roses';
  if(/(^|-)hampers?(?:-|$)|gift-baskets?/.test(h))return'hampers';
  if(/standing-flower|funeral|condolence|wreath/.test(h))return'standing';
  if(/(^|-)gifts?(?:-|$)/.test(h))return'gifts';
  if(/cake/.test(h))return'cakes';
  if(/send-flowers|(^|-)flowers?(?:-|$)|bouquet/.test(h))return'flowers';
  return'generic';
}

function facetRelevant(root,k){
  const ctx=collectionContext(root);
  if(k==='flower-type'&&['hampers','gifts','cakes'].includes(ctx))return false;
  if(k==='flower-type'&&ctx==='standing')return false;
  if(k==='color'&&['hampers','gifts','standing','cakes'].includes(ctx))return false;
  if(k==='delivery'&&root?.dataset?.faLocationMode==='dedicated-city')return false;
  if(k==='recipient'&&ctx==='standing')return false;
  return true;
}

function labelFor(d,k){
  const root=d.closest(ROOT),ctx=collectionContext(root);
  if(k==='delivery')return'Delivery to';
  if(k==='product-type'){
    if(ctx==='hampers')return'Hamper Type';
    if(ctx==='gifts')return'Gift Type';
    if(ctx==='cakes')return'Cake Type';
    if(ctx==='standing')return'Arrangement Type';
    if(ctx==='flowers'||ctx==='roses')return'Arrangement';
    return'Product Type';
  }
  if(k==='flower-type'){
    if(ctx==='roses')return'Rose Type';
    return'Flower Type';
  }
  if(k==='color')return ctx==='roses'?'Rose Colour':'Colour';
  if(LABEL[k])return LABEL[k];
  const t=d.querySelector(':scope>summary span:first-child')?.textContent?.trim();
  return t||k.replace(/-/g,' ').replace(/\b\w/g,m=>m.toUpperCase());
}

function ensureSummary(d,k){
  if(!(d instanceof HTMLDetailsElement)){
    const nd=document.createElement('details');
    nd.id=d.id;
    nd.className=d.className;
    [...d.attributes].forEach(a=>{if(a.name!=='id'&&a.name!=='class')nd.setAttribute(a.name,a.value)});
    const select=d.querySelector('select[name="sort_by"]');
    nd.innerHTML='<summary class="mobile-facets__summary focus-inset"><div><span>Sort</span><span class="mobile-facets__arrow" aria-hidden="true"></span></div></summary><div class="mobile-facets__submenu gradient"><div class="fa-v9-sort-host"></div></div>';
    if(select)nd.querySelector('.fa-v9-sort-host').append(select);
    d.replaceWith(nd);
    return nd;
  }
  let s=d.querySelector(':scope>summary');
  if(!s){
    s=document.createElement('summary');
    s.className='mobile-facets__summary focus-inset';
    s.innerHTML='<div><span></span><span class="mobile-facets__arrow" aria-hidden="true"></span></div>';
    d.prepend(s);
  }
  if(!s.querySelector('.mobile-facets__arrow')){
    const holder=s.querySelector('div')||s;
    const arrow=document.createElement('span');
    arrow.className='mobile-facets__arrow';
    arrow.setAttribute('aria-hidden','true');
    holder.append(arrow);
  }
  return d;
}

function state(root){
  let s=STATE.get(root);
  if(!s){
    s={snapshot:null,lastFocus:null,sortDirty:false,initialSort:null,applying:false};
    STATE.set(root,s);
  }
  return s;
}

function makeSort(root){
  const {list}=parts(root);
  if(!list)return;
  let d=[...list.children].find(x=>x.id&&x.id.includes('Details-Mobile-SortBy'));
  if(!d)return;
  d=ensureSummary(d,'sort');
  d.dataset.faV9Key='sort';
  const select=d.querySelector('select[name="sort_by"]');
  if(!select)return;
  select.classList.add('fa-v9-sort-select');
  const s=state(root);
  if(s.initialSort===null)s.initialSort=select.value;
  let host=d.querySelector('.fa-v9-sort-host')||d.querySelector('.mobile-facets__submenu')||d;
  let rows=d.querySelector('.fa-v9-sort-list');
  if(!rows){
    rows=document.createElement('div');
    rows.className='fa-v9-sort-list';
    host.append(rows);
  }
  rows.innerHTML='';
  [...select.options].forEach(o=>{
    const b=document.createElement('button');
    b.type='button';
    b.className='fa-v9-sort-option'+(o.selected?' is-active':'');
    b.dataset.faV9SortValue=o.value;
    let name=o.textContent.trim();
    const map={'created-descending':'Newest','title-ascending':'Name: A - Z','title-descending':'Name: Z - A','price-ascending':'Price: Low to High','price-descending':'Price: High to Low'};
    b.textContent=map[o.value]||name;
    rows.append(b);
  });
}

function nativeDetails(root){
  const {list}=parts(root);
  if(!list)return[];
  return [...list.children].filter(x=>x.classList&&x.classList.contains('js-filter')&&!x.hidden&&!x.classList.contains('fa-facet-deprecated')&&!x.classList.contains('fa-category-hidden')&&x.getAttribute('aria-hidden')!=='true');
}

function hasUsefulValues(d,k){
  if(!d)return false;
  if(k==='sort')return true;
  if(k==='price'){
    const inputs=[...d.querySelectorAll('input[name="filter.v.price.gte"],input[name="filter.v.price.lte"]')];
    return inputs.some(x=>Number(String(x.dataset.max||x.max||'0').replace(/,/g,''))>0)||inputs.some(x=>String(x.value||'').trim());
  }
  if(k==='delivery'&&d.dataset.faTagCity==='true')return d.querySelectorAll('[data-fa-city-tag-option]').length>1;
  const inputs=[...d.querySelectorAll('input[type="checkbox"],input[type="radio"]')].filter(x=>!x.dataset.faSyntheticFacet);
  const usable=inputs.filter(x=>!x.disabled||x.checked);
  const active=usable.some(x=>x.checked);
  return active||usable.length>1;
}

function prepare(root){
  makeSort(root);
  const {list}=parts(root);
  if(!list)return[];
  [...list.children].filter(d=>d.classList?.contains('fa-v9-relevance-hidden')).forEach(d=>{
    d.classList.remove('fa-v9-relevance-hidden');
    d.hidden=false;
    d.removeAttribute('aria-hidden');
  });
  let ds=nativeDetails(root).map(d=>{
    const k=keyFor(d);
    if(!facetRelevant(root,k)||!hasUsefulValues(d,k)){
      d.classList.add('fa-v9-relevance-hidden');
      d.hidden=true;
      d.setAttribute('aria-hidden','true');
      return null;
    }
    d=ensureSummary(d,k);
    d.dataset.faV9Key=k;
    const label=labelFor(d,k);
    const node=d.querySelector(':scope>summary>div>span:first-child')||d.querySelector(':scope>summary span:first-child');
    if(node)node.textContent=label;
    return d;
  }).filter(Boolean);
  const footer=list.querySelector(':scope>.mobile-facets__footer');
  ds.sort((a,b)=>{
    const ai=ORDER.indexOf(a.dataset.faV9Key),bi=ORDER.indexOf(b.dataset.faV9Key);
    return (ai<0?99:ai)-(bi<0?99:bi);
  }).forEach(d=>list.insertBefore(d,footer||null));
  return ds;
}

function addSearch(d){
  if(!d||d.dataset.faV9Key!=='delivery'||d.querySelector('.fa-v9-search'))return;
  const ul=d.querySelector('.mobile-facets__list,.fa-city-tag-list');
  if(!ul||ul.querySelectorAll('.mobile-facets__item').length<9)return;
  const box=document.createElement('div');
  box.className='fa-v9-search';
  box.innerHTML='<input type="search" autocomplete="off" placeholder="Search city, state or area" aria-label="Search delivery city, state or area"><p class="fa-v9-search-empty" hidden>No matching delivery area.</p>';
  ul.parentElement.insertBefore(box,ul);
  const input=box.querySelector('input'),empty=box.querySelector('p');
  input.addEventListener('input',()=>{
    const q=norm(input.value);
    let visible=0;
    ul.querySelectorAll('.mobile-facets__item').forEach(li=>{
      const ok=!q||norm(li.textContent).includes(q);
      li.hidden=!ok;
      if(ok)visible++;
    });
    ul.querySelectorAll('[data-fa-location-group-title]').forEach(title=>{
      const group=title.dataset.faLocationGroupTitle;
      const any=[...ul.querySelectorAll('.mobile-facets__item[data-fa-location-group="'+group+'"]')].some(li=>!li.hidden);
      title.hidden=!any;
    });
    empty.hidden=visible>0;
  });
}

function pricePresets(d){
  if(!d||d.dataset.faV9Key!=='price')return;
  const host=d.querySelector('.mobile-facets__submenu');
  if(!host||host.querySelector('.fa-v9-price-presets'))return;
  const ranges=[['< RM300','',300],['RM300 - RM500',300,500],['RM500 - RM750',500,750],['RM750 - RM1,000',750,1000],['RM1,000 - RM1,500',1000,1500],['> RM1,500',1500,'']];
  const grid=document.createElement('div');
  grid.className='fa-v9-price-presets';
  ranges.forEach(r=>{
    const b=document.createElement('button');
    b.type='button';
    b.className='fa-v9-price-preset';
    b.textContent=r[0];
    b.dataset.min=String(r[1]);
    b.dataset.max=String(r[2]);
    grid.append(b);
  });
  host.append(grid);
}

function groupCount(d){
  if(!d)return 0;
  const k=d.dataset.faV9Key;
  if(k==='sort')return 0;
  if(k==='price'){
    return [...d.querySelectorAll('input[name="filter.v.price.gte"],input[name="filter.v.price.lte"]')].some(x=>String(x.value||'').trim())?1:0;
  }
  const synthetic=d.querySelectorAll('input[data-fa-synthetic-facet]');
  if(synthetic.length)return [...synthetic].filter(x=>x.checked&&!x.disabled).length;
  if(d.dataset.faTagCity==='true'){
    const root=d.closest(ROOT),city=parseCitySource(root);
    if(city?.mode==='collection-route')return window.FACollectionCityFilter?.dirty?.(root)?1:0;
    const selected=window.FACollectionCityFilter?.selected?.(root);
    return selected?1:0;
  }
  return [...d.querySelectorAll('input[type="checkbox"]:checked,input[type="radio"]:checked')].filter(x=>!x.disabled).length;
}

function totalCount(root){
  const seen=new Set();
  let n=0;
  nativeDetails(root).forEach(d=>{
    const k=d.dataset.faV9Key||keyFor(d);
    if(k==='sort')return;
    if(k==='delivery'&&d.dataset.faTagCity==='true'){
      if(seen.has('delivery'))return;
      seen.add('delivery');
      n+=groupCount(d);
      return;
    }
    n+=groupCount(d);
  });

  if(n===0){
    const params=new URLSearchParams(location.search);
    const logical=new Set();
    params.forEach((value,key)=>{
      if(!key.startsWith('filter.')||!String(value||'').trim())return;
      if(key==='filter.v.price.gte'||key==='filter.v.price.lte'){
        logical.add('price');
        return;
      }
      logical.add(key+'='+value);
    });
    n=logical.size;
  }
  return n;
}

function header(root){
  const h=root.querySelector('.mobile-facets__heading');
  if(!h)return;
  const n=totalCount(root);
  h.textContent=n?(n+' FILTER'+(n===1?'':'S')+' SELECTED'):'NO FILTERS SELECTED';
}

function toolbar(root,ds){
  let bar=root.querySelector('.fa-v9-toolbar');
  if(!bar){
    bar=document.createElement('div');
    bar.className='fa-v9-toolbar';
    const anchor=root.querySelector('.mobile-facets__wrapper');
    root.insertBefore(bar,anchor||root.firstChild);
  }
  const unique=[];
  const seen=new Set();
  ds.forEach(d=>{
    const k=d.dataset.faV9Key||keyFor(d);
    if(seen.has(k))return;
    seen.add(k);
    unique.push(d);
  });
  bar.innerHTML='';
  unique.forEach(d=>{
    const k=d.dataset.faV9Key||keyFor(d);
    const b=document.createElement('button');
    b.type='button';
    b.className='fa-v9-toolbar__button'+(groupCount(d)?' is-selected':'');
    b.dataset.faV9Open=k;
    b.setAttribute('aria-expanded','false');
    let toolbarLabel=labelFor(d,k);
    if(k==='delivery'&&d.dataset.faTagCity==='true'){
      const chosen=window.FACollectionCityFilter?.selected?.(root);
      if(chosen)toolbarLabel+=': '+chosen;
    }
    b.innerHTML='<span>'+toolbarLabel+'</span><span class="fa-v9-toolbar__caret" aria-hidden="true"></span>';
    bar.append(b);
  });
}

function parseCitySource(root){
  const h=root.dataset.collectionHandle||'';
  const nodes=[...document.querySelectorAll('.fa-city-tag-source')];
  const node=nodes.find(x=>x.dataset.collectionHandle===h)||nodes[0];
  if(!node)return null;
  try{return JSON.parse(node.textContent)}catch(_){return null}
}

function renderChips(root){
  let strip=root.querySelector('.fa-v9-active-strip');
  const bar=root.querySelector('.fa-v9-toolbar');
  if(!strip){
    strip=document.createElement('div');
    strip.className='fa-v9-active-strip';
    root.insertBefore(strip,bar||root.firstChild);
  }
  strip.innerHTML='';
  const used=new Set();
  const add=(label,href)=>{
    label=String(label||'').replace(/\s+/g,' ').trim();
    if(!label)return;
    if(label.includes(':'))label=label.split(':').slice(1).join(':').trim();
    const key=norm(label);
    if(!label||used.has(key))return;
    used.add(key);
    const a=document.createElement('a');
    a.className='fa-v9-chip';
    a.href=href;
    a.textContent=label;
    a.setAttribute('aria-label','Remove '+label+' filter');
    strip.append(a);
  };
  root.querySelectorAll('.active-facets-mobile a.active-facets__button').forEach(a=>{
    const clone=a.cloneNode(true);
    clone.querySelectorAll('.svg-wrapper,.visually-hidden').forEach(x=>x.remove());
    add(clone.textContent,a.href);
  });
  const city=parseCitySource(root);
  if(city?.activeCity&&city.mode!=='collection-route'){
    const u=new URL(location.href);
    u.pathname=city.baseUrl||u.pathname.split('/').slice(0,3).join('/');
    u.searchParams.delete('page');
    add(city.activeCity,u.pathname+(u.search||''));
  }
  if(!strip.children.length){strip.remove();return}
  const clear=document.createElement('a');
  clear.className='fa-v9-clear-link';
  clear.textContent='Clear';
  const cityData=parseCitySource(root);
  clear.href=cityData?.baseUrl||((location.pathname.split('/').slice(0,3).join('/'))||location.pathname);
  strip.append(clear);
}

function ensureClose(root){
  const {inner}=parts(root);
  const headerInner=inner?.querySelector('.mobile-facets__header-inner');
  if(!headerInner||headerInner.querySelector('.fa-v9-close'))return;
  const b=document.createElement('button');
  b.type='button';
  b.className='fa-v9-close';
  b.setAttribute('aria-label','Close filters');
  b.innerHTML='<span aria-hidden="true">×</span>';
  headerInner.prepend(b);
}

function ensureActions(root){
  const {inner}=parts(root);
  if(!inner||inner.querySelector('.fa-v9-actions'))return;
  const a=document.createElement('div');
  a.className='fa-v9-actions';
  a.innerHTML='<button type="button" class="fa-v9-clear">Clear All</button><button type="button" class="fa-v9-view">View</button>';
  inner.append(a);
}

function snapshot(root){
  const {form}=parts(root);
  if(!form)return;
  const s=state(root);
  if(s.snapshot)return;
  s.snapshot=[...form.querySelectorAll('input,select')].map(el=>({el,checked:'checked'in el?el.checked:null,value:el.value}));
  s.sortDirty=false;
}

function restore(root){
  const s=state(root);
  if(!s.snapshot)return;
  s.snapshot.forEach(x=>{
    if(!x.el?.isConnected)return;
    if(x.checked!==null)x.el.checked=x.checked;
    x.el.value=x.value;
  });
  s.snapshot=null;
  s.sortDirty=false;
  window.FACollectionCityFilter?.cancel?.(root);
  syncUI(root);
}

function scrollFacetIntoView(root,target){
  const {list}=parts(root);
  if(!list||!target)return;
  requestAnimationFrame(()=>{
    const lr=list.getBoundingClientRect(),tr=target.getBoundingClientRect();
    const next=Math.max(0,list.scrollTop+(tr.top-lr.top)-1);
    list.scrollTo({top:next,behavior:'auto'});
  });
}

function refreshToolbarState(root){
  const ds=nativeDetails(root);
  root.querySelectorAll('.fa-v9-toolbar__button').forEach(b=>{
    const d=ds.find(x=>(x.dataset.faV9Key||keyFor(x))===b.dataset.faV9Open);
    b.classList.toggle('is-selected',!!d&&groupCount(d)>0);
  });
}

function openDrawer(root,key,trigger){
  const p=parts(root);
  if(!p.disclosure||!p.opener)return;
  snapshot(root);
  state(root).lastFocus=trigger||document.activeElement;
  if(!p.disclosure.open)p.opener.click();
  document.body.classList.add('fa-filter-v9-open');
  root.classList.add('fa-v9-editing');
  const details=nativeDetails(root);
  let target=details.find(d=>(d.dataset.faV9Key||keyFor(d))===key);
  if(!target){
    const candidates=[...p.list.querySelectorAll(':scope > .js-filter')];
    target=candidates.find(d=>(d.dataset.faV9Key||keyFor(d))===key&&!d.hidden&&d.getAttribute('aria-hidden')!=='true');
  }
  if(target){
    details.forEach(d=>{if(d!==target&&d.open)d.open=false});
    target.open=true;
    scrollFacetIntoView(root,target);
    const focusable=target.querySelector('input:not([disabled]),button:not([disabled]),select:not([disabled])');
    requestAnimationFrame(()=>focusable?.focus?.({preventScroll:true}));
  }
  root.querySelectorAll('.fa-v9-toolbar__button').forEach(b=>b.setAttribute('aria-expanded',b.dataset.faV9Open===key?'true':'false'));
  header(root);
}

function closeDrawer(root,doRestore=true){
  const p=parts(root),s=state(root);
  if(doRestore)restore(root);else s.snapshot=null;
  s.applying=false;
  if(p.disclosure?.open)p.opener?.click();
  root.classList.remove('fa-v9-editing');
  document.body.classList.remove('fa-filter-v9-open');
  root.querySelectorAll('.fa-v9-toolbar__button').forEach(b=>b.setAttribute('aria-expanded','false'));
  requestAnimationFrame(()=>s.lastFocus?.focus?.({preventScroll:true}));
}

function syncSort(root){
  const select=root.querySelector('#FacetsWrapperMobile select[name="sort_by"]');
  if(!select)return;
  root.querySelectorAll('.fa-v9-sort-option').forEach(b=>b.classList.toggle('is-active',b.dataset.faV9SortValue===select.value));
}

function syncPrice(root){
  const d=nativeDetails(root).find(x=>(x.dataset.faV9Key||keyFor(x))==='price');
  if(!d)return;
  const min=d.querySelector('input[name="filter.v.price.gte"]')?.value||'';
  const max=d.querySelector('input[name="filter.v.price.lte"]')?.value||'';
  d.querySelectorAll('.fa-v9-price-preset').forEach(b=>b.classList.toggle('is-active',String(b.dataset.min||'')===String(min)&&String(b.dataset.max||'')===String(max)));
}

function syncUI(root){
  const ds=prepare(root);
  ds.forEach(d=>{addSearch(d);pricePresets(d)});
  toolbar(root,ds);
  ensureClose(root);
  ensureActions(root);
  header(root);
  syncSort(root);
  syncPrice(root);
  renderChips(root);
  root.classList.add('fa-filter-v9-ready');
}

function clearAll(root){
  const {form}=parts(root);
  if(!form)return;
  form.querySelectorAll('input[type="checkbox"],input[type="radio"]').forEach(x=>{
    if(!x.classList.contains('fa-v9-ui-only'))x.checked=false;
  });
  form.querySelectorAll('input[name="filter.v.price.gte"],input[name="filter.v.price.lte"]').forEach(x=>x.value='');
  const select=form.querySelector('select[name="sort_by"]');
  const s=state(root);
  if(select&&s.initialSort!==null)select.value=s.initialSort;
  s.sortDirty=false;
  const cityData=parseCitySource(root);
  if(cityData?.mode==='collection-route')window.FACollectionCityFilter?.cancel?.(root);
  else window.FACollectionCityFilter?.stage?.(root,'All Malaysia','');
  syncUI(root);
}

function buildUrl(root){
  const {form}=parts(root);
  if(!form)return location.pathname+location.search;
  const s=state(root);
  let path=location.pathname;
  if(window.FACollectionCityFilter?.target){
    try{path=new URL(window.FACollectionCityFilter.target(root,false),location.origin).pathname}catch(_){}
  }
  const params=new URLSearchParams();
  const current=new URLSearchParams(location.search);
  const fd=new FormData(form);
  fd.forEach((v,k)=>{
    if(k.startsWith('fa-v9'))return;
    let val=String(v||'').trim();
    if(k==='filter.v.price.gte'||k==='filter.v.price.lte')val=cleanPriceValue(val);
    if(!val)return;
    if(k==='sort_by'&&!s.sortDirty&&!current.has('sort_by'))return;
    if(k==='page')return;
    params.append(k,val);
  });
  const q=params.toString();
  return path+(q?'?'+q:'');
}

function apply(root){
  const url=buildUrl(root);
  const now=location.pathname+location.search;
  const s=state(root);
  s.applying=true;
  s.snapshot=null;
  if(url===now){closeDrawer(root,false);return}
  location.assign(url);
}

function bindDetails(root){
  nativeDetails(root).forEach(d=>{
    if(d.dataset.faV9Bound)return;
    d.dataset.faV9Bound='1';
    d.addEventListener('toggle',()=>{
      if(d.open){
        nativeDetails(root).forEach(other=>{if(other!==d&&other.open)other.open=false});
      }
      header(root);
      toolbar(root,nativeDetails(root));
      syncPrice(root);
    });
  });
}

function sync(root){
  syncUI(root);
  bindDetails(root);
  const p=parts(root);
  if(p.disclosure&&!p.disclosure.dataset.faV9Bound){
    p.disclosure.dataset.faV9Bound='1';
    p.disclosure.addEventListener('toggle',()=>{
      if(p.disclosure.open){
        snapshot(root);
        root.classList.add('fa-v9-editing');
        document.body.classList.add('fa-filter-v9-open');
      }else if(root.classList.contains('fa-v9-editing')&&!state(root).applying){
        restore(root);
        root.classList.remove('fa-v9-editing');
        document.body.classList.remove('fa-filter-v9-open');
      }
    });
  }
}

function schedule(){cancelAnimationFrame(raf);raf=requestAnimationFrame(()=>document.querySelectorAll(ROOT).forEach(sync))}

document.addEventListener('input',e=>{
  const root=e.target.closest?.(ROOT);
  if(!root||!root.classList.contains('fa-v9-editing'))return;
  if(!e.target.closest('#FacetFiltersFormMobile'))return;
  e.stopImmediatePropagation();
  header(root);
  refreshToolbarState(root);
  syncPrice(root);
},true);

document.addEventListener('change',e=>{
  const root=e.target.closest?.(ROOT);
  if(!root||!root.classList.contains('fa-v9-editing'))return;
  if(!e.target.closest('#FacetFiltersFormMobile'))return;
  if(e.target.matches?.('input[data-fa-synthetic-facet]')){
    setTimeout(()=>{header(root);refreshToolbarState(root);syncPrice(root)},0);
    return;
  }
  e.stopImmediatePropagation();
  header(root);
  refreshToolbarState(root);
  syncPrice(root);
},true);

document.addEventListener('click',e=>{
  const root=e.target.closest?.(ROOT)||e.target.closest?.('#main-collection-filters')?.querySelector?.(ROOT);
  const open=e.target.closest?.('[data-fa-v9-open]');
  if(open&&root){e.preventDefault();openDrawer(root,open.dataset.faV9Open,open);return}
  const close=e.target.closest?.('.fa-v9-close');
  if(close&&root){e.preventDefault();closeDrawer(root,true);return}
  const clear=e.target.closest?.('.fa-v9-clear');
  if(clear&&root){e.preventDefault();clearAll(root);return}
  const view=e.target.closest?.('.fa-v9-view');
  if(view&&root){e.preventDefault();apply(root);return}
  const sort=e.target.closest?.('.fa-v9-sort-option');
  if(sort&&root){
    e.preventDefault();
    const select=root.querySelector('#FacetsWrapperMobile select[name="sort_by"]');
    if(select){select.value=sort.dataset.faV9SortValue;state(root).sortDirty=true;syncSort(root)}
    return;
  }
  const preset=e.target.closest?.('.fa-v9-price-preset');
  if(preset&&root){
    e.preventDefault();
    const d=preset.closest('.mobile-facets__details');
    const min=d?.querySelector('input[name="filter.v.price.gte"]');
    const max=d?.querySelector('input[name="filter.v.price.lte"]');
    if(min)min.value=preset.dataset.min||'';
    if(max)max.value=preset.dataset.max||'';
    header(root);syncPrice(root);refreshToolbarState(root);return;
  }
  const overlay=e.target.closest?.('.mobile-facets');
  if(overlay&&root&&!e.target.closest('.mobile-facets__inner')){e.preventDefault();closeDrawer(root,true)}
},true);

document.addEventListener('keydown',e=>{
  if(e.key!=='Escape')return;
  const root=[...document.querySelectorAll(ROOT)].find(r=>parts(r).disclosure?.open);
  if(root){e.preventDefault();closeDrawer(root,true)}
},true);

document.addEventListener('fa:city-staged',e=>{const root=e.detail?.root||document.querySelector(ROOT);if(root)syncUI(root)});
document.addEventListener('fa:synthetic-staged',e=>{
  const root=e.detail?.root;
  if(!root)return;
  header(root);
  refreshToolbarState(root);
  syncPrice(root);
});
document.addEventListener('fa:facets-updated',schedule);
document.addEventListener('shopify:section:load',schedule);
window.addEventListener('pageshow',schedule);
window.addEventListener('popstate',schedule);

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();

})();
